import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 1A50CD86-0127-4730-A090-ED5110A9825F
 * name water-circle
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-circle.svg
 * tags
 * - Home Automation 
 */
export const WaterCircleIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 19C9.24 19 7 16.76 7 14C7 10.67 12 5.04 12 5.04S17 10.67 17 14C17 16.76 14.76 19 12 19Z" /></>, 'WaterCircleIcon');
export default WaterCircleIcon